import { useQuery } from '@tanstack/react-query'
import { minutesToMillis } from 'helpers'
import { QueryKeys } from '../../key-registry'
import { toNewsPost } from '../models/mapper'
import { NewsPost } from '../models/types'
import { fetchNewsPostByIdV1 } from './http'

export async function fetchNewsPost(id: number, opts?: { signal?: AbortSignal }): Promise<NewsPost> {
  return toNewsPost(await fetchNewsPostByIdV1(id, opts))
}

export function useNewsPostQuery(postId: number | null) {
  return useQuery({
    queryKey: QueryKeys.news.post(postId),
    queryFn: ({ signal }) => fetchNewsPost(postId as number, { signal }),
    enabled: postId !== null,
    staleTime: minutesToMillis(1),
    retry: false,
  })
}
